const routes = {
  home: "/",
  login: "/login",
  profile: "/perfil",
  products: "/productos",
  about: "/nosotros",
};

export default routes;  